import { apiClient } from 'config/api';

/**
 * Service to resend the Auth0 confirmation email
 * @async
 * @param body - body payload request.
 * @param body.userId - user id to resend the email.
 */
async function postResendEmail({ userId }: { userId: string }) {
  const url = `/auth0/user/${userId}/resend-email`;

  const response = await apiClient.post(url);
  return response.data;
}
export default postResendEmail;
